import React from "react";

function FillScreen({ children }: { children?: React.ReactNode }) {
  return <div className="c-fill-screen">{children}</div>;
}

export default FillScreen;
